import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  fetchAdminCompanyDetail,
  fetchAdminDriverDetail,
} from '../../../api/admin.member';

interface LocationState {
  memberType: string; // 필요한 데이터의 타입을 여기에 정의합니다.
}

interface DetailMemvberDriverDtoRx {
  memberType: string;
  passid: string;
  phone: string;
  registration: string;
}

interface DetailMemberCompanyDtoRx {
  memberType: string;
  passid: string;
  phone: string;
  name: string;
  address: string;
  addressDivision: string;
  charge: string;
  position: string;
  registration: string;
}

const AdminMemberDetail = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation<LocationState>();
  const history = useHistory();
  const { state } = location;
  const [driverDetailData, setDriverDetailData] =
    useState<DetailMemvberDriverDtoRx>();
  const [companyDetailData, setCompanyDetailData] =
    useState<DetailMemberCompanyDtoRx>();

  const memberType = state.memberType === '기사' ? 'driver' : 'company';

  useEffect(() => {
    const getDriverDetailData = async () => {
      try {
        if (memberType === 'driver') {
          const response = await fetchAdminDriverDetail(Number(id));
          setDriverDetailData(response);
        } else if (memberType === 'company') {
          const respose = await fetchAdminCompanyDetail(Number(id));
          setCompanyDetailData(respose);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getDriverDetailData();
  }, []);

  const closeBtnHandler = () => {
    history.push('/admin/member/list');
  };

  return (
    <Container>
      <div className="inner">
        <div className="title">회원 정보</div>
        <div className="detail-info-wrap">
          <ul>
            {memberType === 'driver' && driverDetailData ? (
              <>
                <li>
                  <span>회원 구분</span>
                  <p>{driverDetailData.memberType}</p>
                </li>
                <li>
                  <span>아이디</span>
                  <p>{driverDetailData.passid}</p>
                </li>
                <li>
                  <span>휴대폰 번호</span>
                  <p>{driverDetailData.phone}</p>
                </li>
                <li className="image">
                  <span>자동차 등록증</span>
                  <div className="img-box">
                    <img
                      src={driverDetailData.registration}
                      alt="자동차 등록증"
                    />
                  </div>
                </li>
              </>
            ) : memberType === 'company' && companyDetailData ? (
              <>
                <li>
                  <span>회원 구분</span>
                  <p>{companyDetailData.memberType}</p>
                </li>
                <li>
                  <span>아이디</span>
                  <p>{companyDetailData.passid}</p>
                </li>
                <li>
                  <span>휴대폰 번호</span>
                  <p>{companyDetailData.phone}</p>
                </li>
                <li>
                  <span>회사명</span>
                  <p>{companyDetailData.name}</p>
                </li>
                <li>
                  <span>회사 주소</span>
                  <p>{companyDetailData.address}</p>
                </li>
                <li>
                  <span>지역 구분</span>
                  <p>{companyDetailData.addressDivision}</p>
                </li>
                <li>
                  <span>담당자</span>
                  <p>{companyDetailData.charge}</p>
                </li>
                <li>
                  <span>담당자 직책</span>
                  <p>{companyDetailData.position}</p>
                </li>
                <li className="image company">
                  <span>사업자 등록증</span>
                  <div className="img-box">
                    <img
                      src={companyDetailData.registration}
                      alt="사업자 등록증"
                    />
                  </div>
                </li>
              </>
            ) : (
              <li>
                <p className="no-info">회원 정보가 없습니다.</p>
              </li>
            )}
          </ul>
        </div>
        <div className="btn-box">
          <button onClick={closeBtnHandler}>닫 기</button>
        </div>
      </div>
    </Container>
  );
};

export default AdminMemberDetail;

// style
const Container = styled.div`
  margin-top: 7rem;
  overflow-y: scroll;
  .inner {
    max-width: 40.2rem;
    width: 100%;
    margin: 0 auto;
    .title {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 2.4rem;
    }
    .detail-info-wrap {
      ul {
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
        li {
          display: flex;
          align-items: center;
          padding: 0 0.8rem;
          height: 4.2rem;
          span {
            display: inline-flex;
            width: 9.6rem;
            font-size: 1.4rem;
            font-weight: 600;
            color: #222;
          }
          p {
            display: inline-flex;
            font-size: 1.4rem;
            color: #555;
            &.no-info {
              color: #000;
            }
          }
          &:not(:last-child) {
            border-bottom: 1px solid #eee;
          }
          &.image {
            flex-direction: column;
            align-items: flex-start;
            padding-bottom: 10rem;
            height: auto;
            span {
              height: 4.2rem;
              align-items: center;
              margin-bottom: 0.6rem;
            }
            .img-box {
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 20rem;
              width: 100%;
              img {
                max-width: 100%;
                width: 100%;
              }
            }
            &.company {
              padding-bottom: 0;
            }
          }
        }
      }
    }
    .btn-box {
      margin-top: 2.4rem;
      display: flex;
      justify-content: center;
      margin-bottom: 4rem;
      button {
        padding: 1.1rem 1rem;
        white-space: nowrap;
        border: none;
        outline: none;
        background-color: ${(props) => props.theme.btnBlueColor};
        color: ${(props) => props.theme.textWhiteColor};
        border-radius: 0.8rem;
        font-size: 1.5rem;
        width: 10rem;
      }
    }
  }
`;
